
import { Calendar } from 'lucide-react';

interface TodaysProgressCardProps {
  todaysProgress: {
    completed: number;
    total: number;
  };
}

const TodaysProgressCard = ({ todaysProgress }: TodaysProgressCardProps) => {
  const getMotivationalMessage = () => {
    if (todaysProgress.total === 0) {
      return "Ready to create your first PACT?";
    }
    if (todaysProgress.completed === todaysProgress.total) {
      return "Amazing! You showed up today! 🌟";
    }
    if (todaysProgress.completed === 0) {
      return "Today is a new chance to show up!";
    }
    return `${todaysProgress.completed} of ${todaysProgress.total} done. Keep going!`;
  };

  const getProgressPercentage = () => {
    if (todaysProgress.total === 0) return 0;
    return Math.round((todaysProgress.completed / todaysProgress.total) * 100);
  };

  return (
    <div className="pact-card mb-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 bg-vibrant-orange/10 rounded-full flex items-center justify-center">
            <Calendar className="w-6 h-6 text-vibrant-orange" />
          </div>
          <div>
            <h2 className="font-semibold text-deep-blue">Today's Progress</h2>
            <p className="text-sm text-deep-blue/70">
              {new Date().toLocaleDateString('en-US', { 
                weekday: 'long', 
                month: 'short', 
                day: 'numeric' 
              })}
            </p>
          </div>
        </div>
        <div className="text-right">
          <div className="text-2xl font-bold text-vibrant-orange">
            {getProgressPercentage()}%
          </div>
          <div className="text-xs text-deep-blue/70">Complete</div>
        </div>
      </div>
      
      {todaysProgress.total > 0 && (
        <div className="w-full bg-soft-blue rounded-full h-2">
          <div 
            className="bg-vibrant-orange h-2 rounded-full transition-all duration-500"
            style={{ 
              width: `${(todaysProgress.completed / todaysProgress.total) * 100}%` 
            }}
          />
        </div>
      )}
    </div>
  );
};

export default TodaysProgressCard;
